import * as React from 'react'

import moment, { Moment } from 'moment'

interface Props {
  date: Moment
}

const context = React.createContext<Props>({ date: moment() })

export const DateBookingProvider = context.Provider
export const useDateBookingContext = () => React.useContext(context)
